import {Component, ElementRef, ViewChild} from '@angular/core';
import {IonicPage, NavController, NavParams, Content, ActionSheetController, AlertController, ToastController} from 'ionic-angular';
import {UserProvider} from "../../providers/user";
import {TeamappProvider} from "../../providers/teamapp";
import {ImageProvider} from "../../providers/image";
import {Geolocation} from "@ionic-native/geolocation";
import {Camera} from "@ionic-native/camera";
import {Contacts} from "@ionic-native/contacts";
import {PhotoLibrary} from "@ionic-native/photo-library";
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';
/**
 * Generated class for the ChatSinglePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-chat-single',
  templateUrl: 'chat-single.html',
})
export class ChatSinglePage {
  @ViewChild(Content) content: Content;
  @ViewChild('myInput') myInput: ElementRef;

  params: any = [];
  enableUserDownloadPhoto: boolean = false;
  enableUserDownloadVideo: boolean = false;

  singleChatExecuteTime: any;

  message: string;
  oldSize: number = 0;
  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public userProvider: UserProvider,
      public teamappProvider: TeamappProvider,
      public actionSheet: ActionSheetController,
      public imageProvider: ImageProvider,
      public geolocation: Geolocation,
      public camera: Camera,
      public contacts: Contacts,
      public alertCtrl: AlertController,
      public toastController: ToastController,
      public photoLibrary: PhotoLibrary,
      private iab: InAppBrowser,
  )
  {
    this.params = this.navParams.get('params');
    this.params.messages.reverse();
    console.log(this.params);
  }


  ionViewDidEnter() {
    this.loadSingleChat(true);
    this.listenToSingleChat();
  }

  ionViewWillLeave() {
    console.log('CLOSE TIMER')
    this.stopListenToSingleChat();
  }

  viewUser(user: any) {

  }

  isSender(message: any) {
    if(message.from == this.userProvider.getUserID())return true;
    return false;
  }


  messageMenu(message: any) {
    if(this.isSender(message) == false) {
      if(message.type=='image') {
        const actionSheet = this.actionSheet.create({
          title: 'Nachricht',
          buttons: [
            {
              text: 'In Galerie speichern',
              handler: () => {
                this.photoLibrary.requestAuthorization({read:true,write:true}).then(() => {
                  this.photoLibrary.saveImage(message.content, 'teamapp');
                  let toast = this.toastController.create({
                    message: 'Bild erfolgreich gespeichert',
                    duration: 6000,
                    position: 'bottom',
                    showCloseButton: true,
                    closeButtonText: 'Schließen'
                  });
                  toast.present();
                  /**/
                })
                    .catch(err => console.log(err));

              }
            },
            {
              text: 'Abbrechen',
              role: 'cancel',
              handler: () => {

              }
            }
          ]
        });
        actionSheet.present();
      } else if(message.type=='video') {
        const actionSheet = this.actionSheet.create({
          title: 'Nachricht',
          buttons: [
            {
              text: 'Löschen',
              handler: () => {

              }
            },
            {
              text: 'In Galerie speichern',
              handler: () => {
                this.photoLibrary.requestAuthorization({read:true,write:true}).then(() => {
                  this.photoLibrary.saveVideo(message.content, 'teamapp');
                  let toast = this.toastController.create({
                    message: 'Video erfolgreich gespeichert',
                    duration: 6000,
                    position: 'bottom',
                    showCloseButton: true,
                    closeButtonText: 'Schließen'
                  });
                  toast.present();
                  /**/
                })
                    .catch(err => console.log(err));

              }
            },
            {
              text: 'Abbrechen',
              role: 'cancel',
              handler: () => {

              }
            }
          ]
        });
        actionSheet.present();
      } else if(message.type == 'single') {

        let url = this.urlify(message.content);
        console.log(url);
        if(url) {
          const actionSheet = this.actionSheet.create({
            title: 'Nachricht',
            buttons: [
              {
                text: 'Link im Browser öffnen',
                handler: () => {
                  this.openLink(url);
                }
              },
              {
                text: 'Kopieren',
                handler: () => {
                  this.copyMessage(message.content);
                  let toast = this.toastController.create({
                    message: 'Erfolgreich in die Zwischenablage kopiert',
                    duration: 6000,
                    position: 'bottom',
                    showCloseButton: true,
                    closeButtonText: 'Schließen'
                  });
                  toast.present();
                }
              },
              {
                text: 'Abbrechen',
                role: 'cancel',
                handler: () => {

                }
              }
            ]
          });
          actionSheet.present();
        } else {
          const actionSheet = this.actionSheet.create({
            title: 'Nachricht',
            buttons: [
              {
                text: 'Kopieren',
                handler: () => {
                  this.copyMessage(message.content);
                  let toast = this.toastController.create({
                    message: 'Erfolgreich in die Zwischenablage kopiert',
                    duration: 6000,
                    position: 'bottom',
                    showCloseButton: true,
                    closeButtonText: 'Schließen'
                  });
                  toast.present();
                }
              },
              {
                text: 'Abbrechen',
                role: 'cancel',
                handler: () => {

                }
              }
            ]
          });
          actionSheet.present();
        }


      }
    } else {

      if(message.type == 'single') {

        let url = this.urlify(message.content);
        console.log(url);
        if(url) {
          const actionSheet = this.actionSheet.create({
            title: 'Nachricht',
            buttons: [
              {
                text: 'Link im Browser öffnen',
                handler: () => {
                  this.openLink(url);
                }
              },
              {
                text: 'Kopieren',
                handler: () => {
                  this.copyMessage(message.content);
                  let toast = this.toastController.create({
                    message: 'Erfolgreich in die Zwischenablage kopiert',
                    duration: 6000,
                    position: 'bottom',
                    showCloseButton: true,
                    closeButtonText: 'Schließen'
                  });
                  toast.present();
                }
              },
              {
                text: 'Löschen',
                handler: () => {
                  this.teamappProvider.http_request('action=delete_message&target='+message.uid, 'chat', false, true).then(data => {
                    console.log("delete message");
                    console.log(data);
                    message.type = 'deleted';
                  });

                }
              },
              {
                text: 'Abbrechen',
                role: 'cancel',
                handler: () => {

                }
              }
            ]
          });
          actionSheet.present();
        } else {
          const actionSheet = this.actionSheet.create({
            title: 'Nachricht',
            buttons: [
              {
                text: 'Kopieren',
                handler: () => {
                  this.copyMessage(message.content);
                  let toast = this.toastController.create({
                    message: 'Erfolgreich in die Zwischenablage kopiert',
                    duration: 6000,
                    position: 'bottom',
                    showCloseButton: true,
                    closeButtonText: 'Schließen'
                  });
                  toast.present();
                }
              },
              {
                text: 'Löschen',
                handler: () => {
                  this.teamappProvider.http_request('action=delete_message&target='+message.uid, 'chat', false, true).then(data => {
                    console.log("delete message");
                    console.log(data);
                    message.type = 'deleted';
                  });

                }
              },
              {
                text: 'Abbrechen',
                role: 'cancel',
                handler: () => {

                }
              }
            ]
          });
          actionSheet.present();
        }
      } else if(message.type=='image') {
        const actionSheet = this.actionSheet.create({
          title: 'Nachricht',
          buttons: [
            {
              text: 'In Galerie speichern',
              handler: () => {
                this.photoLibrary.requestAuthorization({read:true,write:true}).then(() => {
                  this.photoLibrary.saveImage(message.content, 'teamapp');
                  let toast = this.toastController.create({
                    message: 'Bild erfolgreich gespeichert',
                    duration: 6000,
                    position: 'bottom',
                    showCloseButton: true,
                    closeButtonText: 'Schließen'
                  });
                  toast.present();

                })
                    .catch(err => console.log(err));

              }
            },
            {
              text: 'Löschen',
              handler: () => {
                this.teamappProvider.http_request('action=delete_message&target='+message.uid, 'chat', false, true).then(data => {
                  console.log("delete message");
                  console.log(data);
                  message.type = 'deleted';
                });

              }
            },
            {
              text: 'Abbrechen',
              role: 'cancel',
              handler: () => {

              }
            }
          ]
        });
        actionSheet.present();
      } else if(message.type=='video') {
        const actionSheet = this.actionSheet.create({
          title: 'Nachricht',
          buttons: [
            {
              text: 'In Galerie speichern',
              handler: () => {
                this.photoLibrary.requestAuthorization({read:true,write:true}).then(() => {

                  this.photoLibrary.saveVideo(message.content, 'teamapp');
                  let toast = this.toastController.create({
                    message: 'Video erfolgreich gespeichert',
                    duration: 6000,
                    position: 'bottom',
                    showCloseButton: true,
                    closeButtonText: 'Schließen'
                  });
                  toast.present();
                  /**/
                })
                    .catch(err => console.log(err));

              }
            },
            {
              text: 'Löschen',
              handler: () => {
                this.teamappProvider.http_request('action=delete_message&target='+message.uid, 'chat', false, true).then(data => {
                  console.log("delete message");
                  console.log(data);
                  message.type = 'deleted';
                });

              }
            },
            {
              text: 'Abbrechen',
              role: 'cancel',
              handler: () => {

              }
            }
          ]
        });
        actionSheet.present();
      }
    }
  }

  downloadVideo() {

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChatSinglePage');
  }

  loadSingleChat(scrollBottom: boolean = false) {
    this.teamappProvider.http_request('action=get_single_chat&single_target='+this.params.target, 'chat', false, false).then(data => {

      let dataTmp: any = data;
      console.log("SINGLE CHAT DATA => ");
      console.log(data);
      console.log(this.oldSize +" < "+dataTmp.length);
      if(this.oldSize < dataTmp.length) {
        this.params.messages = dataTmp;

        this.oldSize = this.params.messages.length;
        if(scrollBottom === false) {
          let toast = this.toastController.create({
            message: 'Neue Nachricht in diesem Chat',
            duration: 6000,
            position: 'top',
            showCloseButton: true,
            closeButtonText: 'Scrollen'
          });
          toast.onDidDismiss((data, role) => {
            console.log('Dismissed toast');
            console.log(role);
            if (role == "close") {
              this.scrollBottom();
            }
          });
          toast.present();
        }
      }

      if(scrollBottom == true) {
        this.scrollBottom();
      }

    });
  }

  listenToSingleChat() {
    this.singleChatExecuteTime = setInterval( () => {
      this.loadSingleChat();
    }, 6000);
  }

  stopListenToSingleChat() {
    clearInterval(this.singleChatExecuteTime);
  }

  scrollBottom() {

    var that = this;
    setTimeout(function() {
      that.content.scrollToBottom();
    }, 300);

    //this.setMessagesRead();

  }

  attach(){
    let action = this.actionSheet.create({
      title:'Anhang hinzufügen',
      buttons:[{
        text: 'Kamera',
        handler: () =>{
          this.imageProvider.uploadPhotoToChatServer(this.camera.PictureSourceType.CAMERA).then((url) => {
            let textBefore = this.message;
            this.message = url;
            this.addMessage('image');
            this.message = textBefore;
          });
        }
      },{
        text: 'Galerie',
        handler: ()=>{
          this.imageProvider.uploadPhotoToChatServer(this.camera.PictureSourceType.PHOTOLIBRARY).then((url) => {
            this.message = url;
            this.addMessage("image");
          });
        }
      },
        /*{
          text: 'Video',
          handler: () =>{
            this.imageProvider.uploadVideoToChatServer().then(url=>{
              this.message = url;
              this.addMessage("video");
            });
          }
        }*/
        {
          text: 'Standort',
          handler:()=>{
            this.geolocation.getCurrentPosition({
              timeout: 5000
            }).then(res => {
              let oldMessage = this.message;
              let locationMessage = "Standort:<br> lat:"+res.coords.latitude+"<br> lng:"+res.coords.longitude;
              let mapUrl="<a href='https://www.google.com/maps/search/"+res.coords.latitude+","+res.coords.longitude+"'>Öffnen mit Maps</a>";

              let confirm = this.alertCtrl.create({
                title: 'Standort',
                message: locationMessage,
                buttons:[{
                  text:'Abbrechen',
                  handler: () =>{
                    console.log("canceled");
                  }
                },{
                  text: 'Teilen',
                  handler: () =>{
                    this.message = locationMessage+"<br>"+mapUrl;
                    this.addMessage("location");
                    this.message = oldMessage;
                  }
                }]
              });
              confirm.present();
            }, locationErr => {
              console.log("Location Error"+ JSON.stringify(locationErr));
            });
          }
        },{
          text: 'Kontakt',
          handler: () =>{
            this.contacts.pickContact().then( data =>{
              let name;
              if(data.displayName !== null)name = data.displayName;
              else name = data.name.givenName +" "+data.name.familyName;
              let oldMessage = this.message;
              this.message = "<b>Name:</b> "+name+"<br><b>Mobile:</b> <a href='tel:"+data.phoneNumbers[0].value+"'>"+data.phoneNumbers[0].value+"</a>";
              this.addMessage("contact");
              this.message = oldMessage;
            }, err=>{
              console.log(err);
            })
          }
        },{
          text: 'Abbrechen',
          role: 'cancel',
          handler: ()=>{
            console.log("cancelled");
          }
        }]
    });
    action.present();
  }

  copyMessage(val: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  urlify(text) {
    var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    //var urlRegex = /(https?:\/\/[^\s]+)/g;
    let uriRet = '';
    text.replace(urlRegex, function(url,b,c) {
      var url2 = (c == 'www.') ?  'http://' +url : url;
      uriRet = url2;
    })
    return uriRet;
  }

  resize() {
    var element = this.myInput['_elementRef'].nativeElement.getElementsByClassName("text-input")[0];
    var scrollHeight = element.scrollHeight;
    element.style.height = scrollHeight + 'px';
    this.myInput['_elementRef'].nativeElement.style.height = (scrollHeight + 20) + 'px';
  }

  addMessage(type: string = 'single') {
    this.message = this.message.replace('?', '%3F');
    this.message = this.message.replace('&', '%26');

    this.teamappProvider.http_request('action=add_chat&target='+this.params.target+'&type='+type+'&content='+this.message+'&target_type=user_to_user', 'chat', false, true).then(data => {
      this.loadSingleChat(true);
      this.message = '';
    });
  }

  openLink(link: any) {
    const options: InAppBrowserOptions = {
      zoom: 'yes',
      hardwareback: 'yes',
    };
    const browser = this.iab.create(link,'_blank', options);
    browser.on('exit')
        .subscribe(
        ((event) => {

            }
        ));
  }
}



// WEBPACK FOOTER //
// ./src/pages/chat-single/chat-single.ts